import React from "react";

const AccessUnavailable = ({ reason = "We could not verify application access right now. Please try again shortly." }) => (
  <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
    <div style={{ maxWidth: 520, padding: 24, textAlign: "center" }}>
      <h2 style={{ marginBottom: 12 }}>Access service unavailable</h2>
      <p style={{ marginBottom: 12, lineHeight: 1.5 }}>{reason}</p>
      <p style={{ fontSize: 13, opacity: 0.75, lineHeight: 1.5 }}>
        Your account access has not been changed.
      </p>
    </div>
  </div>
);

export default AccessUnavailable;
